import React from 'react';

import classNames from 'classnames';

export default function IndexSkeleton() {
  return (
    <div className='tw-w-full tw-flex-1 tw-pb-18 tw-pt-6'>
      <div className='tw-flex tw-w-full tw-flex-col tw-gap-6'>
        <div className='tw-flex tw-flex-col tw-gap-1'>
          <div className='tw-flex tw-h-10 tw-w-full tw-animate-pulse tw-items-center tw-gap-2.5 tw-px-4'>
            <div className='tw-h-5 tw-w-5 tw-rounded-lg tw-bg-grey-100' />
            <div className='tw-h-5 tw-w-40 tw-rounded-lg tw-bg-grey-100' />
          </div>
          <div className='tw-flex tw-h-8 tw-w-full tw-animate-pulse tw-items-center tw-px-4'>
            <div className='tw-h-6 tw-w-70 tw-rounded-lg tw-bg-grey-100' />
          </div>
        </div>
        <div className='tw-flex tw-flex-col tw-gap-2'>
          <div className='tw-flex tw-h-8 tw-w-full tw-animate-pulse tw-items-center tw-px-4'>
            <div className='tw-h-4 tw-w-20 tw-rounded-lg tw-bg-grey-100' />
          </div>
          <div className='tw-flex'>
            <table className='tw-w-full tw-table-fixed tw-border-separate tw-select-none tw-border-1 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-grey-100 tw-bg-white'>
              <thead>
                <tr>
                  <td className='tw-h-10 tw-animate-pulse tw-bg-grey-050' />
                </tr>
              </thead>
              <tbody>
                {[...Array(25)].map((_, i) => (
                  <tr key={i}>
                    <td
                      className={classNames(
                        'tw-h-13 tw-animate-pulse tw-border-0 tw-border-t-1 tw-border-solid tw-border-grey-100',
                        i % 2 ? 'tw-bg-grey-050' : 'tw-bg-white',
                      )}
                    />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
